import { useState } from "react";
import { faqList } from "@/mocks/faq";

interface FaqAccordionProps {
  limit?: number;
}

export default function FaqAccordion({ limit }: FaqAccordionProps) {
  const list = limit ? faqList.slice(0, limit) : faqList;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {list.map((item, index) => {
        const open = openIndex === index;
        return (
          <div
            key={item.q}
            className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : index)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
            >
              <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                {item.q}
              </span>
              <i
                className={`${
                  open ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-400"
                } shrink-0 text-lg`}
              ></i>
            </button>
            {open ? (
              <p className="border-t border-background-100 px-4 py-4 text-sm leading-relaxed text-foreground-600 font-label md:px-5">
                {item.a}
              </p>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}